import { Image, LI, P } from "../../../../AbstractElements";
import { dynamicImage } from "../../../../Service";
import UserProfileIcons from "./UserProfileIcons";

const UserProfile = () => {
  return (
    <LI className="profile-nav onhover-dropdown px-0 py-0">
      <div className="d-flex profile-media align-items-center">
        <Image className="img-30 h-auto" src={dynamicImage("dashboard/profile.png")} alt="user" />
        <div className="flex-grow-1">
          <span>{"Helen Walter"}</span>
          <P className="mb-0 font-outfit">{"Admin"}
            <i className="fa fa-angle-down" />
          </P>
        </div>
      </div>
      <UserProfileIcons />
    </LI>
  );
};

export default UserProfile;
